module.exports = __webpack_public_path__ + "static/zenbusiness-072f5181aebe139451e3a10675f8a990.png";